import React from 'react';
import { observer } from 'mobx-react-lite';
import { Stack } from '../../../../stack/stack';
import Skeleton from '../../../skeleton';
import { cn } from '../../../../../../utils/tailwind';

interface SkeletonPieChartProps {
    legendItems: number;
    orientation?: 'vertical' | 'horizontal';
}

export const SkeletonPieChart: React.FC<SkeletonPieChartProps> = observer(
    ({ legendItems = 1, orientation = 'horizontal' }) => {
        return (
            <div
                className={cn(
                    'h-full gap-vsmall xxl:gap-medium',
                    orientation === 'horizontal' ? 'grid grid-cols-[1fr_1.5fr]' : 'flex flex-col',
                )}
            >
                <div
                    className={cn(
                        'relative inline-flex w-full pb-[100%] [&_svg]:!overflow-visible',
                        orientation === 'vertical' && 'mx-auto w-[60%] pb-[60%]',
                    )}
                >
                    <div className="absolute inset-0">
                        <Skeleton width={'100%'} height={'100%'} radius={20} />
                    </div>
                </div>
                <div className="relative h-full overflow-auto">
                    <div className="absolute top-0 right-[2rem] bottom-0 left-0 flex flex-col items-center justify-center">
                        {Array.from(Array(legendItems).keys()).map((item) => (
                            <Stack
                                key={item}
                                gap={'small'}
                                direction={'horizontal'}
                                fullWidth
                                justifyContent="space-between"
                            >
                                <Skeleton width={9} />
                                <Skeleton width={4} />
                            </Stack>
                        ))}
                    </div>
                </div>
            </div>
        );
    },
);
